import React from 'react';
import { FiX, FiInfo } from 'react-icons/fi';
import { useSystemNotification } from '../contexts/SystemNotificationContext';

export default function SystemNotificationBanner() {
  // Notification fetch + dismissal state live in SystemNotificationContext so
  // the SW "Update available" banner can suppress itself while this quieter
  // release/update note is visible.
  const { notification, isVisible, dismiss } = useSystemNotification();

  if (!isVisible) return null;

  const postedAt = notification.createdAt
    ? new Date(notification.createdAt).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    })
    : null;

  const handleDismiss = () => {
    dismiss(notification.id);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <div className="border-b border-slate-200 bg-white/95 px-4 py-3 text-slate-700 shadow-sm backdrop-blur">
        <div className="max-w-6xl mx-auto flex items-start gap-3">
          <FiInfo className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#4f7a64]" />
          <div className="flex-1">
            <p className="text-sm font-medium">{notification.message}</p>
            {postedAt && (
              <p className="mt-0.5 text-xs text-slate-500">
                Posted {postedAt}
              </p>
            )}
          </div>
          <button
            onClick={handleDismiss}
            className="rounded-md p-1 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 flex-shrink-0"
            aria-label="Dismiss"
          >
            <FiX className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
